export default {
  config: {
    id: import.meta.env.VITE_GA_MEASUREMENT_ID,
  },
};
